// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__JkAZW","name":"Header_name__1dQSQ","birthday":"Header_birthday__349zl","skeleton":"Header_skeleton__GLJQK"};